export default __webpack_public_path__ + "static/media/in_transit_true.e8033c7a.svg";